import { Component } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-new-password',
  standalone: true,
  imports: [FormsModule, ToastModule],
  providers: [MessageService],
  templateUrl: './new-password.component.html',
  styleUrl: './new-password.component.scss',
})
export class NewPasswordComponent {
  newPassword = '';
  confirmPassword = '';

  constructor(private messageService: MessageService) {}

  updatePassword() {
    if (!this.newPassword || !this.confirmPassword) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Missing fields',
        detail: 'Please fill all fields',
      });
      return;
    }

    if (this.newPassword !== this.confirmPassword) {
      this.messageService.add({
        severity: 'error',
        summary: 'Mismatch',
        detail: 'Passwords do not match',
      });
      return;
    }

    console.log({
      password: this.newPassword,
    });
  }
}
